import { WP_API_URL } from "../constants/wordpress";

export class WordPressPageError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "WordPressPageError";
    this.status = status;
  }
}

function getWpApiBase() {
  if (process.env.NODE_ENV === "development") {
    return "/api/wp";
  }
  return WP_API_URL.replace(/\/+$/, "");
}

export async function fetchPageBySlug(slug, { lang } = {}) {
  if (!slug) {
    throw new WordPressPageError("Page slug is required", 400);
  }

  const params = new URLSearchParams({
    slug,
    _embed: "1",
  });

  if (lang) {
    params.set("lang", lang);
  }

  const url = `${getWpApiBase()}/wp/v2/pages?${params.toString()}`;
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new WordPressPageError(
      `WordPress page fetch failed (${response.status})`,
      response.status,
    );
  }

  const pages = await response.json();
  return pages[0] || null;
}

export async function fetchMediaById(id) {
  if (!id) return null;

  const url = `${getWpApiBase()}/wp/v2/media/${id}`;
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) return null;

  const media = await response.json();
  const width = media.media_details?.width || media.width || null;
  const height = media.media_details?.height || media.height || null;

  return {
    url: media.source_url || null,
    width,
    height,
    alt: String(media.alt_text || "").trim() || stripHtml(media.title?.rendered || ""),
  };
}

export async function fetchMediaMap(ids = []) {
  const uniqueIds = [...new Set(ids.filter((id) => typeof id === "number" && id > 0))];
  const entries = await Promise.all(
    uniqueIds.map(async (id) => {
      const media = await fetchMediaById(id);
      return [id, media];
    }),
  );

  return Object.fromEntries(entries.filter(([, media]) => media?.url));
}

export function getFeaturedImageUrl(page) {
  return page?._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null;
}

export function stripHtml(html = "") {
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}
